export default __webpack_public_path__ + "static/media/dashboardIcon.e07ed90b.svg";